/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

import {IntlMessageFormat} from '#packages/intl-messageformat/core.js'
export * from '#packages/intl-messageformat/core.js'
export * from '#packages/intl-messageformat/error.js'
export * from '#packages/intl-messageformat/formatters.js'
export {IntlMessageFormat}
export default IntlMessageFormat
